'use strict';
(function(root){
  function selection(config, value){
    if(!config.enabled || !config.ready)throw Error(config.labels.blocked);
    if(!['HU','GR'].includes(value.market) || value.market!==config.country)throw Error(config.labels.mismatch);
    if(!['core','plus'].includes(value.plan))throw Error(config.labels.error);
    const provider=value.provider || 'google';
    if(!['google','microsoft','microsoft_no_teams'].includes(provider))throw Error(config.labels.error);
    const variant=value.plan==='core'?config.variants.core:config.variants.plus[provider];
    const huf=value.market==='HU',currency=huf?'HUF':'EUR';
    const monthly=huf?(value.plan==='core'?10000:29900):(value.plan==='core'?27:79);
    const setup=huf?80000:200;
    return {setup:String(config.variants.setup),variant:String(variant),sellingPlan:String(config.sellingPlan),currency,setupCents:setup*100,monthlyCents:monthly*100,total:(setup+monthly)*100};
  }
  function matches(cart, expected){
    if(cart.currency!==expected.currency || cart.items?.length!==2 || cart.item_count!==2)return false;
    const setup=cart.items.find(item=>String(item.variant_id)===expected.setup);
    const monthly=cart.items.find(item=>String(item.variant_id)===expected.variant);
    return !!setup && !!monthly && setup.quantity===1 && monthly.quantity===1 &&
      !setup.selling_plan_allocation && String(monthly.selling_plan_allocation?.selling_plan?.id)===expected.sellingPlan &&
      setup.requires_shipping===false && monthly.requires_shipping===false &&
      setup.final_line_price===expected.setupCents && monthly.final_line_price===expected.monthlyCents && cart.total_price===expected.total;
  }
  function client(config, request){
    let pending=null;
    const endpoint=path=>config.root.replace(/\/?$/, '/')+path;
    async function json(path, payload){
      const response=await request(endpoint(path),payload?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),credentials:'same-origin'}:{credentials:'same-origin',cache:'no-store'});
      const value=await response.json();
      if(!response.ok)throw Error(config.labels.error);
      return value;
    }
    async function create(value){
      const expected=selection(config,value);
      const existing=await json('cart.js');
      if(matches(existing,expected))return existing;
      if(existing.items?.length)throw Error(config.labels.conflict);
      await json('cart/add.js',{items:[{id:expected.setup,quantity:1},{id:expected.variant,quantity:1,selling_plan:expected.sellingPlan}],attributes:{webandstyle_market:value.market,webandstyle_plan:value.plan,webandstyle_provider:value.plan==='plus'?value.provider:'none'}});
      const cart=await json('cart.js');
      if(!matches(cart,expected))throw Error(config.labels.mismatch);
      return cart;
    }
    return {create(value){if(!pending){const task=()=>create(value);pending=(root.navigator?.locks?root.navigator.locks.request('webandstyle-cart',task):task()).finally(()=>{pending=null;});}return pending;}};
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={selection,matches,client};
  else root.WebandstyleCart=client(root.WebandstyleShopify,root.fetch.bind(root));
})(typeof window!=='undefined'?window:globalThis);
